<template>
  <div>
    <!-- <Cabecera></Cabecera> -->
    <main role="main">
      <div class="c-steps-numbers">
        <div class="container">
          <div class="c-steps-numbers__item active">
            <span>1</span>
            <p>Información y <br />antecedentes</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>2</span>
            <p>Patrocinios</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>3</span>
            <p>Declaraciones <br />y compromisos</p>
          </div>
        </div>
      </div>
      <div class="c-form-steps">
        <!-- <div class="requestNumber">
	      		<p>SOLICITUD N° {{globalRequestNumber}}</p>
	      	</div> -->
        <div class="c-form-steps__sections" data-step="01">
          <div class="container">
            <div class="c-form-steps__content step-data">
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <!-- <button @click="testme">test</button> -->
                  <h2>Información de la persona</h2>
                  <form action="#" id="step03_0">
                    <!-- <p class="small">Declaro que: No soy accionista mayoritario o socio con más del 50% de los derechos sobre el capital social, de alguna empresa vinculada directamente a la industria de la construcción que NO sea socia.</p> -->

                    <div>
                      <p>
                        <b
                          >Declaro que: No soy accionista mayoritario o socio
                          con más del 10% de los derechos sobre el capital
                          social, de alguna empresa vinculada directamente a la
                          industria de la construcción que NO sea socia.</b
                        >
                      </p>
                      <div class="md-checkbox">
                        <input
                          id="f1"
                          name="declaracion"
                          tabindex="31"
                          type="checkbox"
                          value="true"
                          v-model="declaracion"
                          @change="setDeclaracion(), declaracionValidation()"
                          :disabled="!this.corregir"
                        />

                        <label for="f1">
                          <!-- <span class="label-input">Especialidades</span> -->
                          Comprendo y acepto
                        </label>
                        <div
                          id="declaracionst02-error"
                          class="errorDeclaracion"
                          v-if="declaracionIsValid === false"
                        >
                          Este campo es obligatorio. Si su situación no refleja
                          lo indicado acá, comunícate con el correo electrónico
                          areasocios@cchc.cl
                        </div>
                      </div>
                    </div>
                  </form>

                  <br /><br />
                  <p>
                    Ingrese los datos de la persona que se desea postular para
                    ser socia de la Cámara Chilena de la Construcción.<br /><br />
                  </p>
                  <!-- Los antecedentes del postulante serán los mismos datos que se utilizarán para representante ante la CChC y contacto de cobranza. -->
                  <form action="#" id="step03_1">
                    <div class="input" ref="name">
                      <label>Nombre</label>
                      <input
                        type="text"
                        tabindex="1"
                        name="nombre_st03"
                        v-model="name"
                        ref="personName"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                        @focus="focus($refs.name)"
                        @blur="
                          blur([$refs.name, $refs.personName.value]),
                            getGlobalName($refs.personName.value)
                        "
                        @keyup="nameValidation()"
                        :disabled="!this.corregir"
                      />
                      <div class="errorlogin" v-if="nameIsValid === false">
                        Ingrese un nombre
                      </div>
                    </div>
                    <div class="input" ref="firstLastname">
                      <label>Apellido Paterno</label>
                      <input
                        type="text"
                        tabindex="2"
                        name="apelllidopaterno_st03"
                        v-model="fatherLastName"
                        ref="fatherLastName"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                        @focus="focus($refs.firstLastname)"
                        @blur="
                          blur([
                            $refs.firstLastname,
                            $refs.fatherLastName.value,
                          ]),
                            getGlobalLastname($refs.fatherLastName.value)
                        "
                        @keyup="firstLastNameValidation()"
                        :disabled="!this.corregir"
                      />
                      <div
                        class="errorlogin"
                        v-if="firstLastnameIsValid === false"
                      >
                        Ingrese un nombre
                      </div>
                    </div>
                    <div class="input" ref="secondLastName">
                      <label>Apellido Materno</label>
                      <input
                        type="text"
                        tabindex="3"
                        name="apelllidomaterno_st03"
                        v-model="motherLastName"
                        ref="motherLastName"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                        @focus="focus($refs.secondLastName)"
                        @blur="
                          blur([
                            $refs.secondLastName,
                            $refs.motherLastName.value,
                          ]),
                            getGlobalSecondLastName($refs.motherLastName.value)
                        "
                        @keyup="secondLastNameValidation()"
                        :disabled="!this.corregir"
                      />
                      <div
                        class="errorlogin"
                        v-if="secondLastNameIsValid === false"
                      >
                        Ingrese un apellido
                      </div>
                    </div>
                    <div class="input active" ref="rut">
                      <label>RUT de la persona</label>
                      <input
                        type="text"
                        disabled
                        name="rutempresa_st03"
                        v-model="rut"
                        ref="rutInput"
                        @focus="focus($refs.rut)"
                        @blur="
                          blur([$refs.rut, $refs.rutInput.value]),
                            getNroSolicitud($refs.rutInput.value)
                        "
                        @keyup="rutValidation($refs.rutInput.value)"
                      />
                      <div class="small-text">
                        Sin puntos y con guión (11111111-1)
                      </div>
                      <div
                        id="loginrut-error"
                        class="errorlogin"
                        v-if="rutIsValid === false"
                      >
                        Ingrese un rut Válido
                      </div>
                    </div>
                    <div class="input " ref="date">
                      <label>Fecha de Nacimiento</label>
                      <date-picker
                        v-model="date"
                        ref="inputDatePicker"
                        :lang="lang"
                        @focus="dateFocus($refs.date)"
                        @change="dateValidation($refs.date)"
                        :disabled-date="(date) => date >= new Date()"
                        valueType="format"
                        tabindex="4"
                        :format="'DD-MM-YYYY'"
                        :disabled="!this.corregir"
                      >
                        <!-- <i slot="icon-clear" class="mx-icon-clear">
	                          <font-awesome-icon :icon="['far', 'calendar']" />
	                        </i> 
	                        <i slot="icon-calendar" class="mx-icon-calendar"
	                          @click="dateValidation($refs.date)">
	                          <font-awesome-icon :icon="['far', 'calendar']" />
	                        </i>  
 -->
                      </date-picker>
                      <div
                        id="giro_st03-error"
                        class="errorlogin"
                        v-if="dateIsValid === false"
                      >
                        Ingrese una fecha
                      </div>
                    </div>

                    <div class="input active" ref="phone">
                      <label>Teléfono</label>
                      <input
                        type="text"
                        disabled
                        name="telefonoempresa_st03"
                        v-model="phone"
                        ref="phoneCompany"
                        @focus="focus($refs.phone)"
                        @blur="blur([$refs.phone, $refs.phoneCompany.value])"
                        @keyup="phoneNumberValidation($refs.phoneCompany.value)"
                      />
                      <div class="small-text">
                        Use el formato +56 0 0000 0000
                      </div>
                      <div
                        id="phonest02-error"
                        class="formerror"
                        v-if="telIsValid === false"
                      >
                        Ingrese un número válido
                      </div>
                    </div>

                    <div class="input active" ref="email">
                      <label>Email</label>
                      <input
                        disabled
                        type="text"
                        tabindex="6"
                        name="emailempresa_st03"
                        v-model="email"
                        ref="emailCompany"
                        @focus="focus($refs.email)"
                        @blur="blur([$refs.email, $refs.emailCompany.value])"
                        @keyup="emailValidation($refs.emailCompany.value)"
                      />
                      <div
                        id="email2st02-error"
                        class="formerror"
                        v-if="emailIsValid === false && this.email !== ''"
                      >
                        Ingrese un email válido
                      </div>
                    </div>

                    <div class="input active">
                      <label>Profesión</label>
                      <div class="input-select">
                        <select
                          name="profesion_st03"
                          tabindex="7"
                          ref="professionInput"
                          
                          :value="selectedProfession"
                          @change="
                          [ 
                            setProfession($refs.professionInput.value),
                            professionValidation()
                          ]"
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled hidden> -->
                          <option value="" selected disabled>
                            Seleccione una Profesión
                          </option>
                          <option
                            v-for="(profession, key) in professions"
                            :value="profession.profession_id"
                            :key="key"
                          >
                            {{ profession.profession }}
                          </option>
                        </select>
                      </div>
                      <div
                        id="profession-error"
                        class="errorlogin"
                        v-if="this.professionIsValid === false"
                      >
                        Ingrese una Profesión
                      </div>
                    </div>
                    <div class="input active">
                      <label>Categoría</label>
                      <div class="input-select">
                        <select
                          tabindex="6"
                          name="categoria_st03"
                          ref="categoryInput"
                          v-model="category"
                          :value="selectedCategory"
                          @change="
                            [
                              setCategory($refs.categoryInput.value),
                              getSubCategory(),
                              categoryValidation(),
                              categoryValidateDefault(),
                            ]
                          "
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled hidden> -->
                          <option value="" selected disabled>
                            Seleccione una Categoría
                          </option>
                          <option
                            v-for="(category, key) in categories"
                            :value="category.categoriaId"
                            :key="key"
                          >
                            {{ category.categoria }}
                          </option>
                        </select>
                      </div>
                      <div
                        id="giro_st03-error"
                        class="errorlogin"
                        v-if="this.categoryIsValid === false"
                      >
                        Ingrese una Categoría
                      </div>
                    </div>
                    <div class="input active">
                      <label>SubCategoría</label>
                      <div class="input-select">
                        <select
                          tabindex="6"
                          name="subcategoria_st03"
                          ref="subcategoryInput"
                          v-model="subcategory"
                          :value="selectedSubCategory"
                          @change="
                            [
                              setSubCategory($refs.subcategoryInput.value),
                              getActivity(),
                              subcategoryValidation(),
                              subcategoryDefault(),
                            ]
                          "
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled hidden> -->
                          <option value="" selected disabled>
                            Seleccione una SubCategoría
                          </option>
                          <option
                            v-for="(subcategory, key) in subcategories"
                            :value="subcategory.idsubCategoria"
                            :key="key"
                          >
                            {{ subcategory.subcategoria }}
                          </option>
                        </select>
                      </div>
                      <div
                        id="giro_st03-error"
                        class="errorlogin"
                        v-if="this.subcategoryIsValid === false"
                      >
                        Ingrese una SubCategoría
                      </div>
                    </div>
                    <div class="input active">
                      <label>Actividad</label>
                      <div class="input-select">
                        <select
                          tabindex="5"
                          name="actividad_st03"
                          ref="activityInput"
                          v-model="activity"
                          
                          :value="selectedActivity"
                          @change="
                          [
                            setActivity($refs.activityInput.value),
                            setActivity($refs.activityInput.value),
                            activityValidation()
                          ]"
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled hidden> -->
                          <option value="" selected disabled>
                            Seleccione una Actividad
                          </option>
                          <option
                            v-for="(activity, key) in activities"
                            :value="activity.idActividad"
                            :key="key"
                          >
                            {{ activity.actividad }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="this.activityIsValid === false"
                        >
                          Ingrese una Actividad
                        </div>
                      </div>
                    </div>
                    <div ref="description">
                      <p style="margin: 0; color:black">Descripción</p>
                      <textarea
                        maxlength="500"
                        stylos="height:100px"
                        tabindex="4"
                        rows="5"
                        cols="45"
                        class="textarea"
                        type="text"
                        name="description"
                        placeholder="Describir brevemente a que se dedica y servicios entregados"
                        v-model.trim="description"
                        ref="descriptionInput"
                        @keyup="
                          DescriptionValidation(),
                            maxlengthDescriptionValidation(
                              $refs.descriptionInput.value.length
                            )
                        "
                        :disabled="!this.corregir"
                        @keydown.tab="
                          collapseTab([$refs.collapse, $refs.collapseMin])
                        "
                      >
                      </textarea>
                      <br />
                      <div
                        id="giro_st03-error"
                        class="ErrormarginTextarea"
                        v-if="descriptionIsValid === false"
                      >
                        Ingrese descripción
                      </div>
                    </div>

                    <!-- <div class="input">
	                      <div class="input-select">
	                        <select
	                          name="especialidad_st03"
	                          tabindex="8"
	                          @input="$event = setSpecialty($event.target.value)"
	                          :value="selectedSpecialty"
	                          @change="specialtyValidation()" :disabled="!this.corregir"
	                          @keydown.tab="collapseTab([$refs.collapse, $refs.collapseMin])"
	                        >
	                          <option value="" selected disabled hidden>
	                            Especialidad
	                          </option>
	                          <option
	                            v-for="(specialty, key) in specialties"
	                            :value="specialty.especialidad_id"
	                            :key="key"
	                          >
	                            {{ specialty.especialidad }}
	                          </option>
	                        </select>
	                      </div>
	                    </div> -->
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-form-drag whitebg small font"
            ref="collapse"
            tabindex="9"
          >
            <div class="container">
              <a
                class="section-minimizar"
                ref="collapseMin"
                @click="collapseClick([$refs.collapse, $refs.collapseMin])"
              >
                {{ collapse }}
              </a>
              <span
                tabindex="11"
                @keydown.tab="collapseTab([$refs.collapse, $refs.collapseMin])"
              ></span>
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <div
                    id="loginrut-error"
                    class="errorFile"
                    v-if="dropzoneIsValid === false"
                  >
                    Ingrese un archivo
                  </div>
                  <h2 tabindex="10">Antecedentes</h2>
                  <p>
                    A continuación ingrese los documentos que acreditan su
                    información. Los documentos requeridos son los siguientes:
                  </p>
                  <ul>
                    <li>
                      Fotocopia de Cédula de Identidad por ambos lados.
                    </li>
                    <!-- <li>
							<b>Tener alguna profesión relacionada con la industria de la construcción, según lo establece la Ley General de Urbanismo y Construcciones, es decir: arquitectos, ingenieros civiles, constructores civiles e ingenieros en construcción.</b>
						</li> -->
                    <li>
                      Currículum Profesional que acredite experiencia en el
                      rubro de la construcción.
                    </li>
                    <li>
                      Copia simple de certificado de título.
                    </li>
                    <li>
                      Certificado de "Sociedades a las que pertenece el contribuyente" del SII.
                    </li>
                    <!-- <li>
							<b>En caso de tener otras profesiones, acreditar experiencia laboral en la industria de la construcción.</b>
						</li>
						<li>
							Currículum Profesional que acredite experiencia en el rubro de la construcción.
						</li>
						<li>
							Copia simple de certificado de título.
						</li>
						<li>
							<b>Que el ejercicio de la profesión lo realice en forma independiente, sin trabajadores a su cargo.</b>
						</li>
						<li>
							<b>Que no sea accionista mayoritario o socio con más del 50% de los derechos sobre el capital social de alguna empresa vinculada directamente a la industria de la construcción que NO sea socia.</b>
						</li> -->
                  </ul>
                  <div
                    class="input"
                    tabindex="12"
                    @keydown.tab="
                      collapseTab2([
                        $refs.collapseAddress,
                        $refs.collapseCommercial,
                      ])
                    "
                  >
                    <vue-dropzone
                      v-if="this.corregir"
                      ref="vueDropzonePN"
                      :useCustomSlot="true"
                      id="dropzonePN"
                      @vdropzone-upload-progress="uploadProgress"
                      :options="dropzoneOptionsPN"
                      @vdropzone-file-added="fileAddedPN"
                      @vdropzone-sending-multiple="sendingFiles"
                      @vdropzone-success-multiple="successPN"
                      @vdropzone-removed-file="removeFilePN"
                      class="border"
                    >
                      <div class="dropzone-custom-content svg">
                        <div class="subtitle"></div>
                      </div>
                    </vue-dropzone>
                    <!-- <AttachmentList
	                      :tempAttachments="getTempAttachments"
	                      :attachments="getAttachments"
	                    /> -->
                  </div>
                  <br />
                  <div>
                    <ul>
                      <li v-for="(doc, index) in files" v-bind:key="doc">
                        {{ doc }}

                        <button
                          class="link btn-red"
                          type="button"
                          @click="removeFileFromFiles(index)"
                          @keydown.tab="
                            collapseTab2([
                              $refs.collapseAddress,
                              $refs.collapseCommercial,
                            ])
                          "
                        >
                          <strong> X </strong>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-form-steps small font"
            ref="collapseAddress"
            tabindex="9"
          >
            <div class="container">
              <a
                class="section-minimizar"
                ref="collapseCommercial"
                @click="
                  collapseClick([
                    $refs.collapseAddress,
                    $refs.collapseCommercial,
                  ])
                "
              >
                {{ collapse }}<span></span>
              </a>
              <div class="c-form-steps__content step-data">
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step03_2">
                      <h2 tabindex="14">Dirección</h2>
                      <div class="input active">
                        <label>Región</label>
                        <div class="input-select">
                          <select
                            name="regioncomercial_st03"
                            tabindex="15"
                            ref="regionComercial"
                            v-model="regionComercial"
                            :value="selectedRegion"
                            @change="
                              [
                                setRegion($refs.regionComercial.value),
                                getProvince(),
                                regionValidation(),
                                regionSetValidationDefault(),
                              ]
                            "
                            :disabled="!this.corregir"
                          >
                            <option value="" selected disabled>
                              Selecciona una Región
                            </option>
                            <option
                              v-for="(region, key) in regions"
                              :value="region.regionId"
                              :key="key"
                            >
                              {{ region.region }}
                            </option>
                          </select>
                          <div
                            id="email2st02-error"
                            class="formerror"
                            v-if="regionIsValid === false"
                          >
                            Ingrese una Región
                          </div>
                        </div>
                      </div>
                      <div class="input active">
                        <label>Provincia</label>
                        <div class="input-select">
                          <select
                            name="provinciacomercial_st03"
                            tabindex="16"
                            v-model="provinciaComercial"
                            ref="provinciaComercial"
                            :value="selectedProvince"
                            @change=" 
                            [
                            setProvince($refs.provinciaComercial.value),
                            getCommune(),
                            provinceValidation()
                            ]"
                            :disabled="!this.corregir"
                          >
                            <!-- <option value="" selected disabled hidden> -->
                            <option value="" selected disabled>
                              Selecciona una Provincia
                            </option>
                            <option
                              v-for="(province, key) in provinces"
                              :value="province.provinciaId"
                              :key="key"
                            >
                              {{ province.provincia }}
                            </option>
                          </select>
                          <div
                            id="email2st02-error"
                            class="formerror"
                            v-if="provinceIsValid === false"
                          >
                            Ingrese una Provincia
                          </div>
                        </div>
                      </div>
                      <div class="input active">
                        <label>Comuna</label>
                        <div class="input-select">
                          <select
                            name="comunacomercial_st03"
                            tabindex="17"
                            v-model="comuna"
                            ref="comuna"
                            :value="selectedCommune"
                            @change=" 
                            [
                              setCommune($refs.comuna.value),
                              communeValidation()
                            ]"
                            :disabled="!this.corregir"
                          >
                            <option value="" selected disabled>
                              Selecciona una Comuna
                            </option>
                            <option
                              v-for="(commune, key) in communes"
                              :value="commune.comunaId"
                              :key="key"
                            >
                              {{ commune.comuna }}
                            </option>
                          </select>
                          <div
                            id="email2st02-error"
                            class="formerror"
                            v-if="communeIsValid === false"
                          >
                            Ingrese una Comuna
                          </div>
                        </div>
                      </div>
                      <div class="input" ref="street">
                        <label>Calle</label>
                        <input
                          type="text"
                          tabindex="18"
                          maxlength="100"
                          name="callecomercial_st03"
                          v-model="street"
                          ref="streetInput"
                          onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                          @focus="focus($refs.street)"
                          @blur="blur([$refs.street, $refs.streetInput.value])"
                          @keyup="streetValidation()"
                          :disabled="!this.corregir"
                        />
                        <div
                          id="email2st02-error"
                          class="formerror"
                          v-if="streetIsValid === false"
                        >
                          Ingrese una Calle
                        </div>
                      </div>
                      <div class="input" ref="number">
                        <label>Número</label>
                        <input
                          type="text"
                          tabindex="19"
                          name="numerocomercial_st03"
                          v-model="streetNumber"
                          maxlength="45"
                          @input="acceptNumber"
                          ref="numberInput"
                          @focus="focus($refs.number)"
                          @blur="blur([$refs.number, $refs.numberInput.value])"
                          @keyup="streetNumberValidation()"
                          :disabled="!this.corregir"
                        />
                        <div
                          id="email2st02-error"
                          class="formerror"
                          v-if="streetNumberIsValid === false"
                        >
                          Ingrese un Número
                        </div>
                      </div>
                      <div class="input" ref="office">
                        <label>Oficina <i>(Opcional)</i></label>
                        <input
                          type="text"
                          tabindex="20"
                          name="oficinacomercial_st03"
                          maxlength="10"
                          v-model="office"
                          ref="officeInput"
                          onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                          @focus="focus($refs.office)"
                          @blur="blur([$refs.office, $refs.officeInput.value])"
                          @keyup="officeValidation()"
                          :disabled="!this.corregir"
                        />
                        <!-- <div
	                          id="email2st02-error"
	                          class="formerror"
	                          v-if="officeIsValid === false"
	                        >
	                          Ingrese una Oficina
	                        </div> -->
                      </div>
                      <div class="input" ref="reference">
                        <label>Punto de Referencia <i>(Opcional)</i></label>
                        <input
                          type="text"
                          tabindex="21"
                          maxlength="100"
                          name="oficinacomercial_st03"
                          v-model="reference"
                          ref="referenceInput"
                          onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 32)|| (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
                          @focus="focus($refs.reference)"
                          @blur="
                            blur([$refs.reference, $refs.referenceInput.value])
                          "
                          @keyup="
                            referenceValidation(),
                              maxlengthReferenceValidation(
                                $refs.referenceInput.value.length
                              )
                          "
                          :disabled="!this.corregir"
                          @keydown.tab="
                            collapseOnceStepTwo([
                              $refs.committeeSelection,
                              $refs.committee,
                            ])
                          "
                        />
                        <div
                          id="email2st02-error"
                          class="formerror"
                          v-if="
                            referenceIsValid === false && this.reference !== ''
                          "
                        >
                          Ingrese un punto de referencia
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  <div class="c-form-steps whitebg small" ref="committeeSelection" tabindex="22">
	            <div class="container">
	            	<a class="section-minimizar" data-formulario="4"
	            	ref="committee"
	                @click="collapseClick([$refs.committeeSelection, $refs.committee])">
	            		{{collapse}}<span></span>
	            	</a>
	              <div class="c-form-steps__content step-data">
	                <div class="row">
	                  <div class="col-md-10 col-lg-10 offset-lg-2">
	                    <form action="#" id="step03_33">
	                      <h2>selección de comités</h2>
	                      <p class="small">Seleccione un comité en el que desee inscribirse, según su experiencia profesional. Apoye su selección en la descripción de cada comité.</p>
	                      <div class="row">
	                        <div class="col-lg-4">
	                          <h3>Infraestructura</h3>
	                          <div class="md-checkbox">
	                            <input id="i1" name="comites" type="radio">
	                            <label for="i1"><span class="label-input">Contratistas Generales</span><span aria-label="Agrupa empresas de ingeniería y de construcción que evalúan, estudian, diseñan y ejecutan obras de infraestructura pública y privada, de edificación no habitacional, y obras industriales en general. Su labor se orienta a búsqueda de soluciones para el sector, especialmente en lo que se refiere a las relaciones contractuales de sus socios con mandantes, subcontratistas, proveedores y trabajadores, buscando que imperen normas éticas y de equidad que aseguren la libre competencia. El Comité investiga las tendencias de inversiones sectoriales y entrega información de interés para orientar a las empresas del sector, principalmente en el logro de la calidad de las obras, cumplimientos de los plazos y de la seguridad de sus trabajadores." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i2" name="comites" type="radio">
	                            <label for="i2"><span class="label-input">Obras Infraestructura Pública</span><span aria-label="Agrupa a empresas de construcción, de ingeniería y de consultoría relacionadas con los contratos de obras de infraestructura de uso público (carreteras, puentes, obras hidráulicas, arquitectura, concesiones, obras sanitarias, ferroviarias, etc). Su labor está orientada al estudio de las inversiones proyectadas por el MOP y otros mandantes de infraestructura de uso público. Analiza las condiciones generales de contratación buscando relaciones contractuales que favorezcan la equidad, transparencia y la incorporación de innovación tecnológica en los procesos constructivos. Mantiene una permanente relación con los diferentes mandantes de infraestructura de uso público (MOP, Empresas Sanitarias, Metro S.A., entre otras)." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i3" name="comites" type="radio">
	                            <label for="i3"><span class="label-input">Concesiones</span><span aria-label="Agrupa a las empresas concesionarias de obras de infraestructura de uso público y de servicios, con el objeto de representar los intereses de las grandes, medianas y pequeñas concesionarias que operan en este ámbito. Sus principales líneas de acción contemplan el perfeccionamiento de la institucionalidad de las concesiones y la ampliación de su ámbito de aplicación; la participación en el debate formativo que afecta a este sector; procurar agilidad en la tramitación de los decretos y en el cumplimiento de los calendarios de licitaciones, así como el desarrollo de otras iniciativas que permitan posicionar esta industria e incrementar la inversión en el ámbito de la infraestructura pública." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                        <div class="col-lg-3">
	                          <h3>Vivienda</h3>
	                          <div class="md-checkbox">
	                            <input id="i4" name="comites" type="radio">
	                            <label for="i4"><span class="label-input">Inmobiliario</span><span aria-label="Agrupa a empresas inmobiliarias, constructoras, instituciones financieras, corredores de propiedades, arquitectos y otros profesionales relacionados con el mercado Inmobiliario. Tiene por finalidad estudiar la oferta y demanda de bienes raíces, mantener el flujo de información sobre necesidades, requerimientos y condiciones del mercado inmobiliario, como, asimismo, el análisis de la normativa referente al desarrollo urbano." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i5" name="comites" type="radio">
	                            <label for="i5"><span class="label-input">Vivienda</span><span aria-label="Agrupa a empresas que se dedican a la construcción y venta de viviendas con subsidio otorgados por el Ministerio de Vivienda y Urbanismo (MINVU) y otras instituciones públicas o privadas. Le corresponde el tratamiento de todas las materias vinculadas con la vivienda subsidiada, especialmente: materias relacionadas con la actividad del MINVU, incluida la vialidad urbana; subsidio habitacional; materias relacionadas con otros programas, tales como lotes con servicio del Ministerio del Interior, obras de construcción de viviendas o de urbanización de iniciativa municipal, etc." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                        <div class="col-lg-4">
	                          <h3>Suministros</h3>
	                          <div class="md-checkbox">
	                            <input id="i6" name="comites" type="radio">
	                            <label for="i6"><span class="label-input">Proveedores</span><span aria-label="Agrupa a empresas distribuidoras y proveedoras de materiales de construcción del país. Desarrolla una labor de promoción, difusión e intercambio de información, y realiza estudios sobre el mercado de la demanda de productos." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i7" name="comites" type="radio">
	                            <label for="i7"><span class="label-input">Industriales</span><span aria-label="Agrupa a empresas industriales, en su mayoría dedicadas a la producción y comercialización de bienes y servicios, cuyo principal destinatario es el sector de la construcción. Constituye la instancia para canalizar las inquietudes del sector industrial, obtener información respecto de la coyuntura económica, laboral, de seguridad industrial, medio ambiental y toda otra materia que de alguna forma pueda influir en el quehacer de la industria de la construcción en nuestro país." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i8" name="comites" type="radio">
	                            <label for="i8"><span class="label-input">Especialidades</span><span aria-label="Agrupa a empresas y profesionales especializados en los diferentes procesos constructivos, principalmente en las áreas de proyectos, confección e instalación. Su labor fundamental es promover el uso de nuevas tecnologías, equipamiento y servicios de la más alta calidad." data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                      </div> 

	                      <div class="row">
	                        <div class="col-lg-4">
	                          <h3>Infraestructura</h3>
	                          <div class="md-checkbox">
	                            <input id="i1" name="comites" type="radio" 
	                            	tabindex="23" 
	                            	value="true" 
	                            	v-model="dataComites.contratista"
								@click="setContratista()" :disabled="!this.corregir">
	                            <label for="i1"><span class="label-input">Contratistas Generales</span><span aria-label=""  @click="show('contratistas-generales')" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i2" name="comites" 
	                            	type="radio" 
	                            	value="true"  
	                            	tabindex="24" 
	                            	v-model="dataComites.obras"
								@click="setObras()" :disabled="!this.corregir">
	                            <label for="i2"><span class="label-input">Obras Infraestructura Pública</span><span aria-label="" @click="show('obras-infra')" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i3" name="comites" 
	                            	type="radio" 
	                            	tabindex="25" 
	                            	value="true" 
	                            	v-model="dataComites.concesiones"
								@click="setConcesiones()" :disabled="!this.corregir">
	                            <label for="i3"><span class="label-input">Concesiones</span><span aria-label="" @click="show('concesiones')" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                        <div class="col-lg-3">
	                          <h3>Vivienda</h3>
	                          <div class="md-checkbox">
	                            <input id="i4" name="comites" 
	                            	type="radio" 
	                            	tabindex="26" 
	                            	value="true" 
	                            	v-model="dataComites.inmobiliario"
								@click="setInmobiliario()" :disabled="!this.corregir">
	                            <label for="i4"><span class="label-input">Inmobiliario</span><span aria-label="" @click="show('inmobiliario')" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i5" name="comites" 
	                            	type="radio" 
	                            	tabindex="27" 
	                            	value="true" 
	                            	v-model="dataComites.vivienda"
								@click="setVivienda()" :disabled="!this.corregir">
	                            <label for="i5"><span class="label-input">Vivienda</span><span @click="show('vivienda')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                        <div class="col-lg-4">
	                          <h3>Suministros</h3>
	                          <div class="md-checkbox">
	                            <input id="i6" name="comites" 
	                            	type="radio"
	                            	tabindex="28" 
	                            	value="true" v-model="dataComites.proveedores"
								@click="setProveedores()" :disabled="!this.corregir">
	                            <label for="i6"><span class="label-input">Proveedores</span><span @click="show('proveedores')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i7" name="comites" 
	                            	type="radio" 
	                            	tabindex="29"
	                            	value="true" 
	                            	v-model="dataComites.industriales"
								@click="setIndustriales()" :disabled="!this.corregir">
	                            <label for="i7"><span class="label-input">Industriales</span><span @click="show('industriales')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                          <div class="md-checkbox">
	                            <input id="i8" 
	                            	name="comites" 
	                            	tabindex="30"
	                            	type="radio" 
	                            	value="true" 
	                            	v-model="dataComites.especialidades"
								@click="setEspecialidades()" :disabled="!this.corregir">
	                            <label for="i8"><span class="label-input">Especialidades</span><span @click="show('especialidades')" aria-label="" data-microtip-position="right" role="tooltip02">?</span></label>
	                          </div>
	                        </div>
	                      </div>
	                    </form>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>-->
          <div class="c-form-drag whitebg">
            <div class="container">
              <div class="c-form-steps__content">
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step03_3">
                      <div
                        v-if="!this.tieneCorreccion"
                        style="display: inline;"
                      >
                        <button
                          class="link prev btn-blue u-mt20 u-mr30 small"
                          type="button"
                          tabindex="31"
                          @click="saveFirstStep()"
                          :disabled="!this.corregir"
                        >
                          Guardar
                        </button>
                      </div>
                      <button
                        class="link btn-red u-mt50 big"
                        id="submitStep05"
                        type="button"
                        tabindex="32"
                        @click="firstStepValidation()"
                      >
                        Guardar y continuar<i class="fa fa-angle-right"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modales para comites -->
      <modal name="contratistas-generales" :height="400">
        <a
          class="close-modal-text"
          @click="$modal.hide('contratistas-generales')"
          >X</a
        >
        <h2>Contratistas Generales</h2>
        <br />
        <p>
          Agrupa empresas de ingeniería y de construcción que evalúan, estudian,
          diseñan y ejecutan obras de infraestructura pública y privada, de
          edificación no habitacional, y obras industriales en general. Su labor
          se orienta a búsqueda de soluciones para el sector, especialmente en
          lo que se refiere a las relaciones contractuales de sus socios con
          mandantes, subcontratistas, proveedores y trabajadores, buscando que
          imperen normas éticas y de equidad que aseguren la libre competencia.
          El Comité investiga las tendencias de inversiones sectoriales y
          entrega información de interés para orientar a las empresas del
          sector, principalmente en el logro de la calidad de las obras,
          cumplimientos de los plazos y de la seguridad de sus trabajadores.
        </p>
      </modal>

      <modal name="obras-infra" :height="400">
        <a class="close-modal-text" @click="$modal.hide('obras-infra')">X</a>
        <h2>Obras Infraestructura Pública</h2>
        <br />
        <p>
          Agrupa a empresas de construcción, de ingeniería y de consultoría
          relacionadas con los contratos de obras de infraestructura de uso
          público (carreteras, puentes, obras hidráulicas, arquitectura,
          concesiones, obras sanitarias, ferroviarias, etc). Su labor está
          orientada al estudio de las inversiones proyectadas por el MOP y otros
          mandantes de infraestructura de uso público. Analiza las condiciones
          generales de contratación buscando relaciones contractuales que
          favorezcan la equidad, transparencia y la incorporación de innovación
          tecnológica en los procesos constructivos. Mantiene una permanente
          relación con los diferentes mandantes de infraestructura de uso
          público (MOP, Empresas Sanitarias, Metro S.A., entre otras).
        </p>
      </modal>

      <modal name="concesiones" :height="400">
        <a class="close-modal-text" @click="$modal.hide('concesiones')">X</a>
        <h2>Concesiones</h2>
        <br />
        <p>
          Agrupa a las empresas concesionarias de obras de infraestructura de
          uso público y de servicios, con el objeto de representar los intereses
          de las grandes, medianas y pequeñas concesionarias que operan en este
          ámbito. Sus principales líneas de acción contemplan el
          perfeccionamiento de la institucionalidad de las concesiones y la
          ampliación de su ámbito de aplicación; la participación en el debate
          formativo que afecta a este sector; procurar agilidad en la
          tramitación de los decretos y en el cumplimiento de los calendarios de
          licitaciones, así como el desarrollo de otras iniciativas que permitan
          posicionar esta industria e incrementar la inversión en el ámbito de
          la infraestructura pública.
        </p>
      </modal>

      <modal name="inmobiliario" :height="400">
        <a class="close-modal-text" @click="$modal.hide('inmobiliario')">X</a>
        <h2>Inmobiliario</h2>
        <br />
        <p>
          Agrupa a empresas inmobiliarias, constructoras, instituciones
          financieras, corredores de propiedades, arquitectos y otros
          profesionales relacionados con el mercado Inmobiliario. Tiene por
          finalidad estudiar la oferta y demanda de bienes raíces, mantener el
          flujo de información sobre necesidades, requerimientos y condiciones
          del mercado inmobiliario, como, asimismo, el análisis de la normativa
          referente al desarrollo urbano.
        </p>
      </modal>

      <modal name="vivienda" :height="400">
        <a class="close-modal-text" @click="$modal.hide('vivienda')">X</a>
        <h2>Vivienda</h2>
        <br />
        <p>
          Agrupa a empresas que se dedican a la construcción y venta de
          viviendas con subsidio otorgados por el Ministerio de Vivienda y
          Urbanismo (MINVU) y otras instituciones públicas o privadas. Le
          corresponde el tratamiento de todas las materias vinculadas con la
          vivienda subsidiada, especialmente: materias relacionadas con la
          actividad del MINVU, incluida la vialidad urbana; subsidio
          habitacional; materias relacionadas con otros programas, tales como
          lotes con servicio del Ministerio del Interior, obras de construcción
          de viviendas o de urbanización de iniciativa municipal, etc.
        </p>
      </modal>

      <modal name="proveedores" :height="400">
        <a class="close-modal-text" @click="$modal.hide('proveedores')">X</a>
        <h2>Proveedores</h2>
        <br />
        <p>
          Agrupa a empresas distribuidoras y proveedoras de materiales de
          construcción del país. Desarrolla una labor de promoción, difusión e
          intercambio de información, y realiza estudios sobre el mercado de la
          demanda de productos.
        </p>
      </modal>

      <modal name="industriales" :height="400">
        <a class="close-modal-text" @click="$modal.hide('industriales')">X</a>
        <h2>Industriales</h2>
        <br />
        <p>
          Agrupa a empresas industriales, en su mayoría dedicadas a la
          producción y comercialización de bienes y servicios, cuyo principal
          destinatario es el sector de la construcción. Constituye la instancia
          para canalizar las inquietudes del sector industrial, obtener
          información respecto de la coyuntura económica, laboral, de seguridad
          industrial, medio ambiental y toda otra materia que de alguna forma
          pueda influir en el quehacer de la industria de la construcción en
          nuestro país.
        </p>
      </modal>

      <modal name="especialidades" :height="400">
        <a class="close-modal-text" @click="$modal.hide('especialidades')">X</a>
        <h2>Especialidades</h2>
        <br />
        <p>
          Agrupa a empresas y profesionales especializados en los diferentes
          procesos constructivos, principalmente en las áreas de proyectos,
          confección e instalación. Su labor fundamental es promover el uso de
          nuevas tecnologías, equipamiento y servicios de la más alta calidad.
        </p>
      </modal>
    </main>
  </div>
</template>

<script>
import Cabecera from "@/components/Cabecera.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

//Vue Dropzone
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import mixin from "@/mixins/mixin.js";

import axios from "axios";
import VueAxios from "vue-axios";
import Swal from "sweetalert2";

export default {
  name: "FirstStep",
  mixins: [mixin],
  components: {
    Cabecera,
    DatePicker,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      name: "",
      fatherLastName: "",
      motherLastName: "",
      rut: "",
      date: "",
      format: "DD-MM-YYYY",
      lang: {
        formatLocale: {
          firstDayOfWeek: 0,
          weekdaysMin: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
          monthsShort: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
          ],
        },

        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
      },

      phone: "+56",
      email: "",

      //Vue Dropzone data
      tempAttachments: [],
      attachments: [],
      dropzoneOptionsPN: {
        // The Url Where Dropped or Selected files will be sent
        url: `https://httpbin.org/post`,
        // File Size allowed in MB
        maxFilesize: 10,
        // Authentication Headers like Access_Token of your application
        headers: {
          Authorization: `Access Token`,
        },
        // The way you want to receive the files in the server
        paramName: function(n) {
          return "file[]";
        },
        //dictDefaultMessage: "Upload Files Here xD",
        //includeStyling: false,
        //previewsContainer: false,
        autoProcessQueue : false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 20,
        addRemoveLinks: true,
        dictRemoveFile: "Eliminar archivo",
        dictCancelUpload: "Cancelar subida",
        dictInvalidFileType: "No puede subir archivos con este formato.",
        dictFileTooBig:
          "El archivo es muy grande ({{filesize}}MB). Máximo: {{maxFilesize}}MB.",
        acceptedFiles: ".jpg, .jpeg, .xls, .xlsx, .pdf, .doc, .docx, .png",
        dictCancelUploadConfirmation:
          "¿Está seguro que desea cancelar esta subida?",
      },

      street: "",
      streetNumber: "",
      office: "",
      reference: "",
      description: "",
      category: "",
      subcategory: "",
      activity: "",
      regionComercial: "",
      provinciaComercial: "",
      comuna: "",

      dataComites: {
        contratista: false,
        obras: false,
        concesiones: false,
        inmobiliario: false,
        vivienda: false,
        proveedores: false,
        industriales: false,
        especialidades: false,
      },

      nameIsValid: "",
      firstLastnameIsValid: "",
      secondLastNameIsValid: "",
      dateIsValid: "",

      professionIsValid: "",
      categoryIsValid: "",
      subcategoryIsValid: "",
      activityIsValid: "",
      specialtyIsValid: "",
      dropzoneIsValid: "",
      regionIsValid: "",
      provinceIsValid: "",
      communeIsValid: "",
      streetIsValid: "",
      descriptionIsValid: "",
      streetNumberIsValid: "",
      referenceIsValid: "",
      officeIsValid: "",
      formIsValid: true,
      requestNumberValue: "",
      datosBasicos: "",
      getfirstStep: "",
      firstStepObject: [],
      storeObjectFirstStep: [""],
      banderaActivarClases: false,
      files: [],
      corregir: true,
      tieneCorreccion: false,
      declaracion: false,
      declaracionIsValid: "",
    };
  },

  methods: {
    ...mapMutations([
      "focus",
      "blur",
      "dateBlur",
      "rutValidation",
      "collapseClick",
      "collapseTab2",
      "collapseTab",
      "collapseOnceStepTwo",
      "dateFocus",
      "setProfession",
      "setCategory",
      "setSubCategory",
      "setActivity",
      "setSpecialty",
      "setVueDropzoneFilePN",
      "requestNumberObject",
      "setRegion",
      "setProvince",
      "setCommune",
      "saveCompletedFormPN",
      "setRutIsValid",
      "setSecondStepValue",
      "setFirstStepValue",
      "getRutGlobal",
      "getGlobalName",
      "getGlobalLastname",
      "getGlobalSecondLastName",
      "phoneNumberValidation",
      "emailValidation",
      "setObjetoFirstStep",
      "setFormatedName",
    ]),
    ...mapActions([
      "getProfession",
      "getCategory",
      "getSubCategory",
      "getActivity",
      "getSpecialty",
      "backgroundUploadPN",
      "getRegion",
      "getProvince",
      "getCommune",
    ]),
    ...mapGetters(["getterObjetoFirstStep"]),
    test(value) {
      //console.log(value);
    },

    testme() {
      setTimeout(() => this.$router.push({ path: "/" }), 60000);
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    setDeclaracion() {
      //console.log("hice click", this.declaracion);
      // //console.log(event);
    },

    /*setContratista() {
				this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.inmobiliario =  this.dataComites.proveedores =  this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false ;
				this.dataComites.contratista  = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setObras() {
				this.dataComites.contratista = this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.inmobiliario =  this.dataComites.proveedores =  this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false ;	
				this.dataComites.obras = 'true'
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setConcesiones() {
				this.dataComites.contratista = this.dataComites.obras = this.dataComites.vivienda =  this.dataComites.inmobiliario =  this.dataComites.proveedores =  this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false ;
				this.dataComites.concesiones = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setVivienda() {
				this.dataComites.contratista = this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.inmobiliario =  this.dataComites.proveedores =  this.dataComites.industriales = this.dataComites.especialidades =  false ;
				this.dataComites.vivienda = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setInmobiliario() {
				this.dataComites.contratista = this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.proveedores =  this.dataComites.industriales = this.dataComites.especialidades = false ;
				this.dataComites.inmobiliario = 'true'
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setProveedores() {
				this.dataComites.contratista = this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.inmobiliario =   this.dataComites.industriales = this.dataComites.especialidades = this.dataComites.vivienda = false ;
				 this.dataComites.proveedores = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
				
			setIndustriales() {
				this.dataComites.contratista = this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.inmobiliario =  this.dataComites.proveedores = this.dataComites.especialidades = this.dataComites.vivienda = false ;
				this.dataComites.industriales = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
			},
			setEspecialidades() {
				this.dataComites.contratista = this.dataComites.obras =  this.dataComites.concesiones = this.dataComites.vivienda =  this.dataComites.inmobiliario =  this.dataComites.proveedores =  this.dataComites.industriales =  this.dataComites.vivienda = false ;
				this.dataComites.especialidades = 'true';
				//console.log('contratista',this.dataComites.contratista);
				//console.log('obras',this.dataComites.obras);
				//console.log('concesiones',this.dataComites.concesiones);
				//console.log('vivienda',this.dataComites.vivienda);
				//console.log('inmobiliario',this.dataComites.inmobiliario);
				//console.log('proveedores',this.dataComites.proveedores);
				//console.log('industriales',this.dataComites.industriales);
				//console.log('especialidades',this.dataComites.especialidades);
				// this.dataComites.especialidades
			},*/

    declaracionValidation() {
      if (this.declaracion) {
        this.declaracionIsValid = true;
      } else {
        this.declaracionIsValid = false;
      }
    },

    nameValidation() {
      if (this.name == "") {
        this.nameIsValid = false;
      } else {
        this.nameIsValid = true;
      }
    },

    firstLastNameValidation() {
      if (this.fatherLastName == "") {
        this.firstLastnameIsValid = false;
      } else {
        this.firstLastnameIsValid = true;
      }
    },

    secondLastNameValidation() {
      if (this.motherLastName == "") {
        this.secondLastNameIsValid = false;
      } else {
        this.secondLastNameIsValid = true;
      }
    },

    dateValidation(refs) {
      if (this.date == "" || this.date == null) {
        //console.log("test me");
        this.dateIsValid = false;
        //this.dateBlur(refs);
      } else {
        this.dateIsValid = true;
      }
    },

    professionValidation() {
      if (this.selectedProfession == "") {
        this.professionIsValid = false;
      } else {
        this.professionIsValid = true;
      }
    },
    categoryValidation() {
      if (this.category == "") {
        this.categoryIsValid = false;
      } else {
        this.categoryIsValid = true;
      }
    },
    categoryValidateDefault() {
      if (this.selectedCategory) {
        this.subcategory = "";
        this.activity = "";
      }
    },
    subcategoryValidation() {
      if (this.subcategory == "") {
        this.subcategoryIsValid = false;
      } else {
        this.subcategoryIsValid = true;
      }
    },
    subcategoryDefault() {
      if (this.selectedSubCategory) {
        this.activity = "";
      }
    },
    activityValidation() {
      if (this.activity == "") {
        this.activityIsValid = false;
      } else {
        this.activityIsValid = true;
      }
    },

    specialtyValidation() {
      if (this.selectedSpecialty == "") {
        this.specialtyIsValid = false;
      } else {
        this.specialtyIsValid = true;
      }
    },

    dropZoneValidation() {
      if (this.vueDropzoneFilePN == "" && this.files == "") {
        this.dropzoneIsValid = false;
        Swal.fire({
          icon: "warning",
          title: "Debe agregar archivos antes de continuar.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
        //alert("Debe agregar archivos antes de continuar.");
      } else {
        this.dropzoneIsValid = true;
      }
    },

    regionValidation() {
      if (this.regionComercial == "") {
        this.regionIsValid = false;
      } else {
        this.regionIsValid = true;
      }
    },
    regionSetValidationDefault() {
      if (this.selectedRegion) {
        this.provinciaComercial = "";
        this.comuna = "";
      }
    },

    provinceValidation() {
      if (this.provinciaComercial == "") {
        this.provinceIsValid = false;
      } else {
        this.provinceIsValid = true;
      }
    },

    communeValidation() {
      if (this.comuna == "") {
        this.communeIsValid = false;
      } else {
        this.communeIsValid = true;
      }
    },
    DescriptionValidation() {
      if (this.description == "") {
        ////console.log(this.description)
        this.descriptionIsValid = false;
      } else {
        this.descriptionIsValid = true;
      }
    },
    maxlengthDescriptionValidation(input) {
      //console.log(input);

      if (input > 500) {
        Swal.fire({
          icon: "warning",
          title: "El máximo de caracteres es 500.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
    },

    streetValidation() {
      if (this.street == "") {
        this.streetIsValid = false;
      } else {
        this.streetIsValid = true;
      }
    },

    streetNumberValidation() {
      if (this.streetNumber == "") {
        this.streetNumberIsValid = false;
      } else {
        this.streetNumberIsValid = true;
      }
    },

    acceptNumber() {
      var x = this.streetNumber
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.streetNumber = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? +x[3] : "");
    },

    officeValidation() {
      if (this.office == "") {
        this.officeIsValid = false;
      } else {
        this.officeIsValid = true;
      }
    },

    referenceValidation() {
      if (this.reference == "") {
        this.referenceIsValid = false;
      } else {
        this.referenceIsValid = true;
      }
    },

    maxlengthReferenceValidation(input) {
      //console.log(input);
      if (input > 100) {
        Swal.fire({
          icon: "warning",
          title: "El máximo de caracteres es 100.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
        //alert("El máximo de caracteres es 100.");
      }
    },

    /*comiteValue() {
		      if (this.dataComites.contratista !== false 
		          || this.dataComites.obras !== false 
		          || this.dataComites.concesiones !== false
		          || this.dataComites.inmobiliario !== false 
		          || this.dataComites.vivienda !== false 
		          || this.dataComites.proveedores !== false
		          || this.dataComites.industriales !== false
		          || this.dataComites.especialidades !== false) {
		              return true;
		          } else {
		            return false;
		          }
		    },*/

    show(modalName) {
      this.$modal.show(modalName);
    },

    hide(modalName) {
      this.$modal.hide(modalName);
    },

    clearDropzone() {
    this.$refs.vueDropzonePN.removeAllFiles(true);
    console.log('files aquip', this.files);
    this.setFormatedName([]);
    },

    getNroSolicitud(rut) {
      axios
        .get(this.URL + "/buscarPostulante/" + rut)
        .then((response) => {
          this.datosBasicos = response.data;
          //console.log(this.datosBasicos);
          //console.log(this.datosBasicos[0].nro_solicitud);
          this.requestNumberValue = this.datosBasicos[0].nro_solicitud;
          const regDate = this.datosBasicos[0].reg_date_bas;
          const id_conecta = this.datosBasicos[0].id_conecta;
          let oneYearAgo = new Date();
              oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
              oneYearAgo = oneYearAgo.toISOString().split('T')[0];
              ////console.log("aquí fechita basica", regDate);
              ////console.log("aquí hoy hace un año", oneYearAgo);
          if(regDate !== null && regDate <= oneYearAgo && id_conecta === null){
            ////console.log("entró a fechita");
            this.$router.push({ name: "Home" });
            Swal.fire({
              icon: 'warning',
              title: 'Solicitud de postulación caducada, para continuar debe iniciar un nuevo proceso.',      
            });
          }
          this.requestNumberObject(this.requestNumberValue);
          //Metodo para efectuar la corrección
          this.validationStep(this.requestNumberValue);
          //console.log(this.requestNumberValue);
          setTimeout(this.getFirstStepRequest(this.requestNumberValue), 3000);
          this.getRutGlobal(rut);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    getFirstStepRequest(number) {
      let requestNumber = number;
      axios
        .get(this.URL + "/paso1/" + requestNumber)
        .then((response) => {
          let firstStepSaved = response.data;
          this.getfirstStep = JSON.parse(firstStepSaved[0].object);
          const estado = JSON.parse(firstStepSaved[0].estado);
          const idConecta = JSON.parse(firstStepSaved[0].idConecta); // nueva modificacion al back
          console.log("se hace el llamado a al getFirstStepRequest")
          if ((estado === 1 && idConecta == null) || estado === 3) {
            // TRAEMOS LA VARIABLE GLOBAL CON EL OBJETO ALMACENADO
            this.storeObjectFirstStep = this.$store.getters.getterObjetoFirstStep;
            if (this.storeObjectFirstStep.length == 1) {
              this.$store.commit("setObjetoFirstStep", this.getfirstStep);
              this.recoveryDataForm(this.getfirstStep);
            } else {
              this.recoveryDataForm(this.storeObjectFirstStep);
            }
            //this.recoveryDataForm()
          }
          if (
            estado === 2 ||
            estado === 0 ||
            (estado === 1 && idConecta != null)
          ) {
            // SE PODRIA EMPLEAR PARA REDIRECCION A HOME
            this.$router.push({ name: "Home" });
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    saveContinueFirstStep() {
      this.backgroundUploadPN();
      var dropzoneArrayPN = this.formatedNameFirstStep;
      let descriptionClean = this.description.replace(
        /_|[^/A-Za-zÁÉÍÓÚáéíóúñÑ\w\s*.()]|\s{2}/g,
        ""
      );
      let descriptionN = descriptionClean.replace(/(\r\n|\n|\r)/gm, "");
      dropzoneArrayPN = dropzoneArrayPN.concat(this.files);
      this.firstStepObject.push({
        firstStep: {
          name: this.name,
          fatherLastName: this.fatherLastName,
          motherLastName: this.motherLastName,
          rut: this.rut,
          date: this.date,
          phone: this.phone,
          email: this.email,
          profession: this.selectedProfession,
          categoryNew: this.selectedCategory,
          subCategory: this.selectedSubCategory,
          activityNew: this.selectedActivity,
          description: descriptionN,
          specialty: this.selectedSpecialty,
          files: dropzoneArrayPN,
          region: this.selectedRegion,
          province: this.selectedProvince,
          commune: this.selectedCommune,
          street: this.street,
          streetNumber: this.streetNumber,
          office: this.office,
          reference: this.reference,
          dataComites: {
            contratista: this.dataComites.contratista,
            obras: this.dataComites.obras,
            concesiones: this.dataComites.concesiones,
            inmobiliario: this.dataComites.inmobiliario,
            vivienda: this.dataComites.vivienda,
            proveedores: this.dataComites.proveedores,
            industriales: this.dataComites.industriales,
            especialidades: this.dataComites.especialidades,
          },
          declaracion: this.declaracion,
        },
      });
      this.saveCompletedFormPN([this.firstStepObject, 1]);
      if (!this.tieneCorreccion) {
        this.savePostFirstStep();
      } else {
        //console.log("TIENE CORRECCION - NO SE GUARDA EN BASE");
      }
      this.firstStepObject = [];
      if(this.corregir){
      this.clearDropzone();
      }
    },

    saveFirstStep() {
      Swal.fire({
        title: "¿Está seguro que desea guardar su postulación?",
        //text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "btn btn-danger",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.backgroundUploadPN();
          var dropzoneArrayPN = this.formatedNameFirstStep;
          /*for (const key in this.vueDropzoneFilePN) {
				          //console.log("key", key);
				          //console.log("value", this.vueDropzoneFilePN[key].name);
				          dropzoneArrayPN.push(this.vueDropzoneFilePN[key].name);
						}*/
          dropzoneArrayPN = dropzoneArrayPN.concat(this.files);
          let descriptionClean = this.description.replace(
            /_|[^/A-Za-zÁÉÍÓÚáéíóúñÑ\w\s*.()]|\s{2}/g,
            ""
          );
          let descriptionN = descriptionClean.replace(/(\r\n|\n|\r)/gm, "");
          //console.log("Dropzone file array before saving in object" + dropzoneArrayPN);
          this.firstStepObject.push({
            firstStep: {
              name: this.name,
              fatherLastName: this.fatherLastName,
              motherLastName: this.motherLastName,
              rut: this.rut,
              date: this.date,
              phone: this.phone,
              email: this.email,
              profession: this.selectedProfession,
              categoryNew: this.selectedCategory,
              subCategory: this.selectedSubCategory,
              activityNew: this.selectedActivity,
              description: descriptionN,
              specialty: this.selectedSpecialty,
              files: dropzoneArrayPN,
              region: this.selectedRegion,
              province: this.selectedProvince,
              commune: this.selectedCommune,
              street: this.street,
              streetNumber: this.streetNumber,
              office: this.office,
              reference: this.reference,
              dataComites: {
                contratista: this.dataComites.contratista,
                obras: this.dataComites.obras,
                concesiones: this.dataComites.concesiones,
                inmobiliario: this.dataComites.inmobiliario,
                vivienda: this.dataComites.vivienda,
                proveedores: this.dataComites.proveedores,
                industriales: this.dataComites.industriales,
                especialidades: this.dataComites.especialidades,
              },
              declaracion: this.declaracion,
            },
          });
          console.log("archivos actualizazdos", this.files)
          this.saveCompletedFormPN([this.firstStepObject, 1]);
          this.savePostFirstStep();
          this.getFirstStepRequest(this.nroSolicitud);
          this.clearDropzone();
          this.firstStepObject = [];

          Swal.fire("¡Datos guardados satisfactoriamente!", "", "success");
        }
      });
    },

    savePostFirstStep: function() {
      let data = JSON.stringify(this.completeObject);
      if (this.completeObject.length > 0) {
        this.savePartial(data);
      } else {
        this.error("warning", "¡Error al guardar, intente de nuevo!");
      }
    },
    // TODO: hacerlo global
    error(icon, title) {
      Swal.fire({
        icon: icon,
        title: title,
      });
    },
    savePartial(data) {
      axios
        .post(this.URL + "/guardarParcial", data)
        .then((response) => {
          //console.log(response.data);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },
    firstStepValidation() {
      if (this.corregir) {
        this.validateForm();
      } else {
        this.nextStepIsValid();
      }
    },
    nextStepIsValid() {
      this.saveContinueFirstStep();
      this.setSecondStepValue(true);
      this.setFirstStepValue(false);
      this.scrollToTop();
    },
    validateForm() {
      this.validRut();
      this.declaracionValidation();
      this.nameValidation();
      this.firstLastNameValidation();
      this.secondLastNameValidation();
      this.professionValidation();
      this.categoryValidation();
      this.subcategoryValidation();
      this.activityValidation();
      this.dropZoneValidation();
      this.regionValidation();
      this.provinceValidation();
      this.communeValidation();
      this.streetValidation();
      this.DescriptionValidation();
      this.streetNumberValidation();
      this.validateLabels();
    },
    validRut() {
      if (this.rut == "" || this.rutIsValid == false) {
        this.setRutIsValid(false);
      } else {
        this.setRutIsValid(true);
      }
    },
    validateLabels() {
      if (
        this.rut == "" ||
        this.rutIsValid == false ||
        this.dateIsValid == false ||
        this.phone == "" ||
        this.email == "" ||
        this.nameIsValid == "" ||
        this.fatherLastName == "" ||
        this.motherLastName == "" ||
        this.selectedProfession == "" ||
        this.category == "" ||
        this.subcategory == "" ||
        this.activity == "" ||
        (this.vueDropzoneFilePN == "" && this.files == "") ||
        this.regionComercial == "" ||
        this.provinciaComercial == "" ||
        this.comuna == "" ||
        this.street == "" ||
        this.description.trim() == "" ||
        this.streetNumber == "" ||
        this.dropzoneIsValid == false ||
        this.declaracionIsValid == false
      ) {
        this.formIsValid = false;
      }else{
        this.formIsValid = true;
      }
      this.nextStep(this.formIsValid);
    },
    nextStep(formIsValid) {
      if (formIsValid == true) {
        this.saveContinueFirstStep();
        //this.$router.push({ name: "StepTwo" });
        this.setSecondStepValue(true);
        this.setFirstStepValue(false);
        this.scrollToTop();
      } else {
        this.scrollToTop();
        Swal.fire({
          icon: "warning",
          title: "Debe completar todos los campos requeridos",
          didDestroy: () => {
            window.scrollTo(0, 0);
          },
        });
        this.setSecondStepValue(false);
      }
    },
    getRut() {
      let routeNumber = this.$route.params.id;
      let number;
      let rut;
      let phone;
      let email;
      //console.log(routeNumber);
      axios
        .get(this.URL + "/getRut/" + routeNumber)
        .then((response) => {
          let data = response.data;
          //console.log(data);
          //console.log(data[0].requestNumber);
          //console.log(data[0].rut);
          //console.log(data[0].email);
          //console.log(data[0].telefono);
          number = data[0].requestNumber;
          rut = data[0].rut;
          phone = data[0].telefono;
          email = data[0].email;
          if (routeNumber == number) {
            //console.log("Match requestNumber");
            this.rut = rut;
            this.phone = phone;
            this.email = email;
            this.$refs.rutInput.value = rut;
            this.getNroSolicitud(this.rut);
            this.rutValidation(this.rut);
          } else {
          }
          ////console.log(this.tipoSocDocs);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },
    // metodo que verifica la correccion del formulario
    validationStep(nroSolicitud) {
      //console.log("Numero de SOLICITUD", nroSolicitud);

      axios
        .get(this.URL + "/validarCorreccion/" + nroSolicitud + "-5")
        .then((response) => {
          let data = response.data;
          //console.log("Response Validar Correccion", data);

          if (data.ESTADO !== "PENDIENTE A ENVÍO") {
            //CORREGIR_PASO viene true si se debe volver a ingresar informacion y false si no se debe corregir, es decir es valido
            this.corregir = data.CORREGIR_PASO;

            this.tieneCorreccion = true; // indica que tomara el camino de correccion
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    recoveryDataForm(objectData) {
      const firstStep = objectData[1].firstStep;
      if (firstStep) {
        /*============== Inicio etapa Informacion de la empresa ================*/
        if (firstStep.declaracion) {
          this.declaracion = firstStep.declaracion;
        }

        if (firstStep.name) {
          this.$refs.name.className = "input active";
          this.name = firstStep.name;
          this.$store.commit("getGlobalName", this.name);
        }
        if (firstStep.fatherLastName) {
          this.$refs.firstLastname.className = "input active";
          this.fatherLastName = firstStep.fatherLastName;
          this.$store.commit("getGlobalLastname", this.fatherLastName);
        }
        if (firstStep.motherLastName) {
          this.$refs.secondLastName.className = "input active";
          this.motherLastName = firstStep.motherLastName;
          this.$store.commit("getGlobalSecondLastName", this.motherLastName);
        }
        if (firstStep.date) {
          this.$refs.date.className = "input active";
          this.date = firstStep.date;
          this.dateValidation(this.$refs.date);
        }

        if (firstStep.phone) {
          this.$refs.phone.className = "input active";
          this.phone = firstStep.phone;
          this.$store.commit("phoneNumberValidation", this.phone);
        }
        if (firstStep.email) {
          this.$refs.email.className = "input active";
          this.email = firstStep.email;
          this.$store.commit("emailValidation", this.email);
        }
        if (firstStep.profession) {
          //cargamos la profesion
          this.$store.commit("setProfession", firstStep.profession);
          this.professionValidation(this.selectedProfession);
        }
        /* ============== Inicio etapa Antecedentes ================*/
        if (firstStep.files.length > 0) {
          this.files = firstStep.files;
          //console.log("files", this.files);
        }

        /*============== Inicio etapa direccion ================*/
        //console.log("region", firstStep.region);
        //console.log("province", firstStep.province);
        //console.log("commune", firstStep.commune);
        if (firstStep.region && firstStep.province && firstStep.commune) {
          //cargamos la region
          this.$store.commit("setRegion", firstStep.region);
          this.regionComercial = firstStep.region;
          //cargamos las provincias
          this.$store.commit("setProvince", firstStep.province);
          this.$store.dispatch("getProvince");
          this.provinciaComercial = firstStep.province;
          // cargamos la communa
          this.$store.commit("setCommune", firstStep.commune);
          this.$store.dispatch("getCommune");
          this.comuna = firstStep.commune;
        }

        //console.log("nuevaCategoria", firstStep.categoryNew);
        //console.log("subCategoria", firstStep.subCategory);
        //console.log("NuevaActividad", firstStep.activityNew);
        if (
          firstStep.categoryNew &&
          firstStep.subCategory &&
          firstStep.activityNew
        ) {
          this.$store.commit("setCategory", firstStep.categoryNew);
          this.category = firstStep.categoryNew;

          //cargamos las subcategorias
          this.$store.commit("setSubCategory", firstStep.subCategory);
          this.$store.dispatch("getSubCategory");
          this.subcategory = firstStep.subCategory;

          //cargarmos las actividades
          this.$store.commit("setActivity", firstStep.activityNew);
          this.$store.dispatch("getActivity");
          this.activity = firstStep.activityNew;
        }
        if (firstStep.street) {
          this.$refs.street.className = "input active";
          this.street = firstStep.street;
        }
        if (firstStep.description) {
          this.$refs.description.className = "input active";
          this.description = firstStep.description;
        }
        if (firstStep.streetNumber) {
          this.$refs.number.className = "input active";
          this.streetNumber = firstStep.streetNumber;
        }
        if (firstStep.office) {
          this.$refs.office.className = "input active";
          this.office = firstStep.office;
        }

        if (firstStep.reference) {
          this.$refs.reference.className = "input active";
          this.reference = firstStep.reference;
        }

        /*  
					============== Inicio etapa seccion de comites ================
					*/
        const dataComites = firstStep.dataComites;
        this.cargarComites(dataComites);
      } else {
        //console.log("No existe recuperacion parcial para el first step");
      }
    },
    cargarComites(dataComites) {
      this.dataComites.contratista = this.dataComites.obras = this.dataComites.concesiones = this.dataComites.vivienda = this.dataComites.inmobiliario = this.dataComites.proveedores = this.dataComites.industriales = this.dataComites.especialidades = false;

      if (dataComites.contratista) {
        this.dataComites.contratista = dataComites.contratista;
      }
      if (dataComites.obras) {
        this.dataComites.obras = dataComites.obras;
      }
      if (dataComites.concesiones) {
        this.dataComites.concesiones = dataComites.concesiones;
      }

      // vivienda
      if (dataComites.vivienda) {
        this.dataComites.vivienda = dataComites.vivienda;
      }
      if (dataComites.inmobiliario) {
        this.dataComites.inmobiliario = dataComites.inmobiliario;
      }

      // suministros
      if (dataComites.proveedores) {
        this.dataComites.proveedores = dataComites.proveedores;
      }
      if (dataComites.industriales) {
        this.dataComites.industriales = dataComites.industriales;
      }
      if (dataComites.especialidades) {
        this.dataComites.especialidades = dataComites.especialidades;
      }

      if (this.corregir === false) {
        //console.log("FORMULARIO VALIDADO");
        this.deshabilitarCampos();
      } else {
        //console.log("SE ACTIVO LA CORRECCION");
      }
    },
    deshabilitarCampos() {
      //console.log("DESHABILITANDO vueDropZone");
      this.$refs.vueDropzonePN.disable();
    },
    removeFileFromFiles(index) {
      if (index > -1 && this.corregir) {
        Swal.fire({
          title: "¿Está seguro de eliminar este archivo?",
          //text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Eliminado satisfactoriamente!", "", "success");
            //console.log("eliminando el elemento con indice " + index);
            this.files.splice(index, 1);
          }
        });
      } else {
        if (this.corregir === false) {
          Swal.fire({
            icon: "warning",
            title: "Opción no disponible para corrección",
          });
          //   Swal.clickConfirm(this.scrollToTop())
        }
      }
    },
  },

  //llama las variables de carpeta store/index.js
  computed: {
    ...mapState([
      "rutIsValid",
      "telIsValid",
      "emailIsValid",
      "collapse",
      "selectedProfession",
      "professions",
      "",
      "selectedSpecialty",
      "specialties",
      "vueDropzoneFilePN",
      "URL",
      "completeObject",
      "regions",
      "categories",
      "selectedCategory",
      "subcategories",
      "selectedSubCategory",
      "activities",
      "selectedActivity",
      "selectedRegion",
      "provinces",
      "selectedProvince",
      "communes",
      "selectedCommune",
      "globalName",
      "globalLastname",
      "globalSecondLastName",
      "globalRequestNumber",
      "formatedNameFirstStep",
    ]),
    disabledInputs() {
      return !this.corregir;
    },
  },

  created: function() {
    this.getProfession();
    this.getSpecialty();
    this.getCategory();
    this.getRegion();
    this.getRut();
    //this.validationStep() Se convoca desde getRut -> getNroSolicitud()
  },
};
</script>
<style>
.mx-datepicker {
  position: relative !important;
  display: inline;
}

.mx-input {
  width: 100% !important;
  border-radius: 0px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
  border-bottom: 1px solid #333;
  padding: 0;
  padding-left: 0;
}

*:disabled {
  color: #ccc;
  border-color: #ccc;
}

.mx-input:disabled,
.mx-input.disabled {
  color: #ccc;
  background-color: #f0f0f0;
  z-index: initial;
  border-color: black;
}

i {
  z-index: 25;
}
label {
  z-index: 25;
}

select:disabled {
  opacity: 0.3;
}

.mx-input:hover {
  border-color: black;
}
.mx-input:focus {
  border-color: black;
}

.mx-calendar:hover .mx-calendar-panel-date:hover {
  border-color: black;
  z-index: 5;
}

.svg {
  background: url(../../assets/img/draganddrop-text.svg) no-repeat center;
  margin-left: 1%;
  height: 40px;
}

.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
  background: #185bc1;
  color: #fff;
  padding: 30px;
}

.vm--modal .close-modal-text {
  cursor: pointer;
  position: absolute;
  font-size: 20px;
  top: 10px;
  right: 20px;
  color: #fff;
}

.vue-dropzone > .dz-preview .dz-error-message {
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  left: 0;
  width: 100%;
  text-align: center;
}

.vue-dropzone > .dz-preview .dz-remove {
  position: absolute;
  z-index: 30;
  color: #fff;
  margin-left: 15px;
  margin-bottom: 35px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  border: 2px #fff solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  opacity: 0;
}

.errorFile {
  font-size: 100%;
  color: red;
  position: relative;
  left: 100%;
}

.errorDeclaracion {
  color: red;
}

.requestNumber {
  background: #185bc1;
  width: 20%;
  height: 50px;
  margin: 20px 0 0 20px;
  text-align: center;
  padding: 10px;
  color: #fff;
}

.requestNumber p {
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
}

*:focus {
  outline: white;
}

.mx-icon-clear {
  cursor: pointer;
  display: none !important;
}

.mx-icon-calendar,
.mx-icon-clear {
  display: none !important;
}
</style>
